import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://127.0.0.1:8000';

const getAuthHeaders = () => {
  const token = localStorage.getItem('clerkToken');
  return {
    Authorization: `Bearer ${token}`,
  };
};

/**
 * GET /dealership/account-settings
 * Returns { profile, dealership_details, contact_information }
 */
export const fetchAccountSettings = () =>
  axios
    .get(`${BASE_URL}/dealership/account-settings`, {
      headers: getAuthHeaders(),
    })
    .then((res) => res.data);

/**
 * GET /api/billing/overview
 * Returns { subscription, default_payment_method, invoices }
 *
 * subscription should include (or equivalents): plan_name, price (dollars), renew_date (ISO).
 * UI also accepts: current_period_end, amount/unit_amount (cents auto-converted), product.name, nickname.
 */
export const fetchBilling = () =>
  axios
    .get(`${BASE_URL}/api/billing/overview`, {
      headers: getAuthHeaders(),
    })
    .then((res) => res.data);

/**
 * POST /subscription/cancel
 * Body (optional): { cancellation_reason: "string" }
 *
 * Backend contract (for testing/verification):
 * - Cancel should be "at end of billing period" (not immediate).
 * - DB must keep subscription_status = "active" until period end (so user keeps access).
 * - Set cancelled: true and/or cancel_at_period_end: true; set actual cancellation date at period end.
 * - Update recommended_listings status as needed (e.g. so listings reflect cancel-at-period-end).
 * - GET /api/billing/overview should return subscription: { status: "active", cancelled: true, renew_date: "<period_end>" }.
 */
export const cancelSubscription = (cancellationReason) =>
  axios.post(
    `${BASE_URL}/subscription/cancel`,
    cancellationReason != null && cancellationReason.trim() !== ""
      ? { cancellation_reason: String(cancellationReason).trim() }
      : {},
    { headers: { ...getAuthHeaders(), 'Content-Type': 'application/json' } }
  ).then((res) => res.data);

/**
 * POST /subscription/undo-cancel
 * Reverts a scheduled cancellation so the subscription renews as normal.
 */
export const undoCancelSubscription = () =>
  axios
    .post(`${BASE_URL}/subscription/undo-cancel`, {}, { headers: { ...getAuthHeaders(), 'Content-Type': 'application/json' } })
    .then((res) => res.data);
